import axios, { AxiosError } from "axios";

const consentAxiosClient = axios.create({
    baseURL: import.meta.env.VITE_PATIENT_PORTAL_API_BASE_URL,
});

let scopedToken: string | null = null;

consentAxiosClient.interceptors.request.use((config) => {
    if (scopedToken) {
        config.headers.set("Authorization", `Bearer ${scopedToken}`);
    } else {
        config.headers.delete("Authorization");
    }

    return config;
});

consentAxiosClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            scopedToken = null;
        }
        return Promise.reject(error);
    }
);

export const setConsentLinkToken = (token: string) => {
    scopedToken = token;
};

export const clearConsentLinkToken = () => {
    scopedToken = null;
};

export const resetConsentLinkClientForTests = () => {
    scopedToken = null;
};

export default consentAxiosClient;
